import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDDialogActions, FDDialogContent, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';


function SuccessLayout() {
  const { resource } = useMetaLayoutContext();
  const { handleSuccess } = useIdentityChallengeContext();

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={2} {...dataAttrs('dicrs-success-layout')}>
          <MetaControlField attr={'primaryText'} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton label={resource.attr('closeText')} onClick={handleSuccess} test={'dicrs-success-layout-close-button'} />
      </FDDialogActions>
    </>
  );
}

SuccessLayout.propTypes = {
};

SuccessLayout.defaultProps = {
};

export default SuccessLayout;
